var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.025 7.67574C14.2594 7.91005 14.2594 8.28995 14.025 8.52426L9.22505 13.3243C8.99073 13.5586 8.61083 13.5586 8.37652 13.3243L5.97652 10.9243C5.7422 10.6899 5.7422 10.3101 5.97652 10.0757C6.21083 9.84142 6.59073 9.84142 6.82505 10.0757L8.80078 12.0515L13.1765 7.67574C13.4108 7.44142 13.7907 7.44142 14.025 7.67574Z",
    fill: "#262524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle2);
export default __webpack_public_path__ + "static/media/check-circle-2.61b844bb264abd75cd53a13d7cac438e.svg";
export { ForwardRef as ReactComponent };